<template>
    <div id="differentGame">
        <headerPage :title="title" :iconSrc="iconSrc" :headerSty="headerSty"></headerPage>
        <headerBg :headerBg="headerBg" class="headerBg"></headerBg>
        <gameImg :game="game"></gameImg>
        <div class="text">
            <div>这是你今年玩过最独特的游戏</div>
            <div>
                只有<span class="span1" :style="colorSty">{{ data.palyProbability }}</span>
                <span class="span2" :style="colorSty">%</span>的玩家玩过
            </div>
            <div>你有一双明亮的眼睛</div>
            <div>
                <span>让你总能在夜空中寻找到最闪耀的那颗星~</span><img src="../../assets/image/steam/right_big.png" />
            </div>
        </div>
        <footerPage class="footerPage"></footerPage>
        <footerBg class="footerBg" :footerBg="footerBg"></footerBg>
    </div>
</template>

<script>
import headerPage from "../../components/header.vue";
import gameImg from "../../components/gameImg.vue";
import footerPage from "../../components/footer.vue";
import footerBg from "../../components/footerBg.vue";
import headerBg from "../../components/headerBg.vue";
export default {
    props: {
        data: {
            type: [Object]
        }
    },
    data() {
        return {
            title: "最与众不同的选择",
            iconSrc: require("../../assets/image/" +
                this.$route.query.type +
                "/" +
                this.$route.query.type +
                "_small.png"),
            headerSty: {
                padding: "7.2rem 0 0 1.95rem"
            },
            footerBg: {
                top: "25rem",
                height: "17rem",
                background:
                    "url(" + require("../../assets/image/" + this.$route.query.type + "/differentGameBg.png") + ")",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
                // backgroundAttachment: 'fixed',
            },
            headerBg: {
                height: "12.45rem",
                background: "url(" + require("../../assets/image/steam/headerBg.png") + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "300%",
                backgroundPosition: "8% 15%"
                //   backgroundAttachment: 'fixed',
            },
            game: {},
            colorSty: {}
        };
    },
    mounted() {
        if (this.$route.query.type == "steam") {
            this.colorSty = {
                color: "#5EE6FF"
            };
        } else if (this.$route.query.type == "psn") {
            this.colorSty = {
                color: "#5EA6FF"
            };
        } else if (this.$route.query.type == "xbox") {
            this.colorSty = {
                color: "#5EFF97"
            };
        } else if (this.$route.query.type == "epic") {
            this.colorSty = {
                color: "#FF5E5E"
            };
        }
        this.$set(this.game, "gameImg", this.data.gameCover);
        this.$set(this.game, "gameName", this.data.gameName);
    },

    methods: {
        getNumber(val) {
            if (val) {
                return val.toFixed(0);
            }
        }
    },
    components: {
        headerPage,
        gameImg,
        footerPage,
        footerBg,
        headerBg
    }
};
</script>

<style>
#differentGame .text {
    padding: 0 1.95rem;
    font-size: 0.7rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.8);
}
#differentGame .text div {
    margin-bottom: 1.35rem;
}
#differentGame .text .span1 {
    font-size: 1.4rem;
    font-family: Impact;
    color: #5ee6ff;
    margin-left: 0.3rem;
}
#differentGame .text .span2 {
    font-size: 0.7rem;
    font-family: Source Han Sans CN;
    color: #5ee6ff;
    margin: 0 0.8rem 0 0.35rem;
}
#differentGame .text > div:last-child {
    display: flex;
    align-items: end;
    justify-content: space-between;
}
#differentGame .text > div:last-child > span {
    margin-bottom: 0.15rem;
}
#differentGame .text img {
    width: 1.8rem;
    height: 1.5rem;
}
</style>
